document.addEventListener('DOMContentLoaded', function () {
  // 选中所有 Shopify section（每个内容区块）作为动画对象
  // Dawn 等 OS 2.0 主题每一个区块都会有 .shopify-section 类
  var sections = document.querySelectorAll('.shopify-section');

  if (!sections.length) return;

  // 过滤掉 header 和 footer 区块，避免导航栏、页脚也一起淡入
  var targets = Array.prototype.filter.call(sections, function (section) {
    var id = section.id || '';
    var classes = section.className || '';

    // 如果是 header-group、footer-group、搜索弹窗之类，可以通过 id/class 排除
    if (id.indexOf('header') !== -1) return false;
    if (id.indexOf('footer') !== -1) return false;
    if (classes.indexOf('header') !== -1) return false;
    if (classes.indexOf('footer') !== -1) return false;

    return true;
  });

  // 给所有目标区块加上初始 class
  targets.forEach(function (el) {
    el.classList.add('scroll-fade-up');
  });

  // 浏览器支持 IntersectionObserver 的情况
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-fade-up--visible');
            observer.unobserve(entry.target); // 只动画一次
          }
        });
      },
      {
        threshold: 0.15 // 区块有 15% 进入视口时触发
      }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    // 兼容非常旧的浏览器：直接全部显示
    targets.forEach(function (el) {
      el.classList.add('scroll-fade-up--visible');
    });
  }
});